export const API_BASE = process.env.OMNIPLATFORM_API;
export const API_PATH = 'legal-entities';
export const CUTOFF_REPORT_DAYS_PATH = 'cutoff-report-days';
export const CUTOFF_REPORT_DAY_OVERRIDES_PATH = 'overrides';
